import { ConditionOperator, PatientDataField } from './condition.schemas';
import { QuestionParameters, QuestionType } from '../questionnaire/question';

export type OperatorRestrictions = {
  [K in QuestionType]: readonly ConditionOperator[];
};

export const OPERATOR_RESTRICTIONS: OperatorRestrictions = {
  text: [
    'equals',
    'not_equals',
    'contains',
    'not_contains',
    'is_empty',
    'is_not_empty',
  ],
  radio: ['equals', 'not_equals', 'is_empty', 'is_not_empty'],
  select: ['equals', 'not_equals', 'is_empty', 'is_not_empty'], // 'contains' and 'not_contains' added dynamically for multi-select
  checkboxes: [
    'equals',
    'not_equals',
    'contains',
    'not_contains',
    'is_empty',
    'is_not_empty',
  ],
  date: [
    'equals',
    'not_equals',
    'greater_than',
    'less_than',
    'between',
    'is_empty',
    'is_not_empty',
  ],
  number: [
    'equals',
    'not_equals',
    'greater_than',
    'less_than',
    'between',
    'is_empty',
    'is_not_empty',
  ],
  document: ['is_empty', 'is_not_empty'],
  voice: ['is_empty', 'is_not_empty'],
} as const;

export const getOperatorRestrictionsForSelect = (
  allowMultiple: boolean,
): readonly ConditionOperator[] => {
  if (allowMultiple) {
    return [...OPERATOR_RESTRICTIONS.select, 'contains', 'not_contains'];
  }
  return OPERATOR_RESTRICTIONS.select;
};

export const getOperatorRestrictions = (
  questionType: QuestionType,
  questionParameters?: QuestionParameters,
): readonly ConditionOperator[] => {
  if (
    questionType === 'select' &&
    questionParameters?.type === 'select' &&
    questionParameters.allowMultiple
  ) {
    return getOperatorRestrictionsForSelect(true);
  }
  return OPERATOR_RESTRICTIONS[questionType];
};

export const getPatientDataFieldOperators = (
  field: PatientDataField,
): readonly ConditionOperator[] => {
  switch (field) {
    case 'birthdate':
      return OPERATOR_RESTRICTIONS.date;
    case 'gender':
      return ['equals', 'not_equals'];
    case 'chronicIllnesses':
      return ['contains', 'not_contains', 'is_empty', 'is_not_empty'];
  }
};
